import classNames from 'classnames';
import React from 'react';
import {prefix, WebUI, getNid} from "../../wui-core/src/index"
import { DrawerFooterProps } from './iDrawer';

const defaultProps = {
    componentClass: 'div' as keyof JSX.IntrinsicElements,
    clsPrefix: `${prefix}-drawer-footer`,
};

const DrawerFooter: React.FC<DrawerFooterProps> = (props) => {
    const {componentClass: Component = defaultProps.componentClass, clsPrefix, className, children, onCustomRender, ...restProps} = props;
    const footerChildren = typeof onCustomRender === 'function' ? onCustomRender(children) : children;

    const classes: any = {};
    classes[`${clsPrefix}`] = true;
    const adapterNid = getNid(props);

    return (
        <Component
            {...restProps}
            className={classNames(className, classes)}
            {...adapterNid}
        >
            {footerChildren}
        </Component>
    );
};

export default WebUI({name: "drawer-footer", defaultProps})(DrawerFooter);
